<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 8C0 3.58172 3.58172 0 8 0H40C44.4183 0 48 3.58172 48 8V40C48 44.4183 44.4183 48 40 48H8C3.58172 48 0 44.4183 0 40V8Z"
      fill="#FCE6F0"
    />
    <path
      d="M27.0007 24C27.0007 25.6569 25.6576 27 24.0007 27C22.3439 27 21.0007 25.6569 21.0007 24C21.0007 22.3431 22.3439 21 24.0007 21C25.6576 21 27.0007 22.3431 27.0007 24Z"
      stroke="#E00069"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.459 24C15.7333 19.9429 19.5235 17 24.0012 17C28.4788 17 32.2691 19.9429 33.5434 24C32.2691 28.0571 28.4788 31 24.0012 31C19.5235 31 15.7332 28.0571 14.459 24Z"
      stroke="#E00069"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup>
import { defineProps } from "vue";

defineProps({
  width: {
    type: [String, Number],
    default: "24",
  },
  height: {
    type: [String, Number],
    default: "24",
  },
  color: {
    type: String,
    default: "#E00069",
  },
  strokeWidth: {
    type: [String, Number],
    default: "2",
  },
});
</script>
